import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
` 

export const Card = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #C8C8C8;
  background-color: #fff;
  padding: 16px;
`

export const ImageContainer = styled.div`
  border-radius: 50%;
  height: 64px;
  width: 64px;
  min-width: 64px;
  background-color: #EBF2F2;
  display: flex;
  align-items: center;
  justify-content: center;

  & img {
    width: 26px;
    height: 26px;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  &&& strong {
    color: #937251;
    font-size: 14px;
    line-height: 21px;
  }

  &&& span {
    color: #65666A;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }
`